export default "__VITE_ASSET__DXva$bfg__"